import { translate } from '@jsverse/transloco';
export enum Confidence {
    TENTATIVE = 'TENTATIVE',
    FIRM = 'FIRM',
    CERTAIN = 'CERTAIN',
}

export class ConfidenceHelper {
    static getConfidenceLocale(confidence: Confidence): string {
        switch (confidence) {
            case Confidence.TENTATIVE:
                return translate('CORE.CONFIDENCES.TENTATIVE');
            case Confidence.FIRM:
                return translate('CORE.CONFIDENCES.FIRM');
            case Confidence.CERTAIN:
                return translate('CORE.CONFIDENCES.CERTAIN');
            default:
                return '';
        }
    }
}
